import { React, useEffect, useRef } from 'libs/react';
import { DealActivityStreamItem } from './DealActivityStreamItem';
import './DealActivityStreamItemsList.scss';
/**
 * @component DealActivityStreamItemsList
 * @since 1.0.0
 */
export function DealActivityStreamItemsList(props) {
    var _a;
    const { data, deal } = props;
    const activityStreamListRef = useRef(null);
    useEffect(() => {
        var _a;
        if (activityStreamListRef.current &&
            ((_a = activityStreamListRef === null || activityStreamListRef === void 0 ? void 0 : activityStreamListRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) >= 1) {
            activityStreamListRef.current.scrollTop =
                activityStreamListRef.current.scrollHeight;
        }
    }, [
        activityStreamListRef,
        (_a = activityStreamListRef === null || activityStreamListRef === void 0 ? void 0 : activityStreamListRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight,
        data
    ]);
    return (React.createElement("div", { className: "deal-activity-stream-items-list", ref: activityStreamListRef }, data.map((item) => (React.createElement(React.Fragment, null,
        React.createElement(DealActivityStreamItem, { item: item, deal: deal }))))));
}
